/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import Group from '../../models/groups';
import Membership from '../../models/membership';
import { PermissionsState, PermissionsTabEnum } from '../permissions.slice';

export default function toggleTotal(
  state: PermissionsState,
  action: PayloadAction<{ groups: Group[]; members: Membership[]; ownerRoles: string[] }>,
) {
  if (state.tab === PermissionsTabEnum.Members) {
    const { groups, members, ownerRoles } = action.payload;
    const groupMembersIds = groups.flatMap((group) => group.memberIds);
    const managedMembers = members.filter(
      (member) => ownerRoles.includes(member.roleName)
      || groupMembersIds.includes(member.id),
    );

    state.hasTotalMembersSelected = !state.hasTotalMembersSelected;

    if (!state.hasTotalMembersSelected) {
      state.selectedMembers = managedMembers;
    }
  }

  if (state.tab === PermissionsTabEnum.Groups) {
    state.hasTotalGroupsSelected = !state.hasTotalGroupsSelected;

    if (!state.hasTotalGroupsSelected) {
      state.selectedGroups = [];
    }
  }
}
